<template>
<a-spin :loading="isLoading">
        <div class="basic-info-view">
            <div class="basic-info-icon">
                <div class="icon-title">{{$t("图标")}}</div>
                <div class="icon-setting">
                    <div class="icon-input-box" @click="handleChangeIcon">
                        <img v-if="spaceIconImg" :src="spaceIconImg" class="icon-show-img" alt=""/>
                        <svg-icon v-if="spaceIconSvg" :name="spaceIconSvg" :color="svgCurrentColor" class="icon-show-svg"></svg-icon>
                    </div>

                    <a-trigger v-model="showMoreIcon" :disabled="triggerDisabled" class="setting-icon-box-trigger" position="bl" trigger="click" :popup-translate="[176, -16]" @hide="showMoreIcon = false">
                        <div class="icon-list">
                            <div class="icon-default-list">
                                <div class="icon-default-item" :class="{ 'more-btn': index === defaultIconList.length - 1 }" v-for="(item, index) in defaultIconList" @click="handleSelectDefaultIcon(item, index)">
                                    <img :src="item" class="icon-default-img" alt=""/>
                                    <!-- <img v-if="index !== defaultIconList.length - 1" :src="item"
                                        class="icon-default-img" alt=""> -->
                                    <!-- <svg-icon v-else :name="item" class="icon-default-more-btn"></svg-icon> -->
                                    <div v-if="item === spaceIconImg" class="icon-default-selected">
                                        <svg-icon name="setting-icon_setting_selected_icon" class="icon-default-selected-icon"></svg-icon>
                                    </div>
                                </div>
                            </div>

                            <div class="icon-change-btn" @click="handleChangeIcon">{{$t("选择更多")}}</div>
                        </div>
                        <template #content>
                            <div class="icon-setting-view">
                                <div class="icon-setting-header">
                                    <div class="icon-header-item" :class="{ 'selected': currentHeaderIndex == idx }" v-for="(item, idx) in triggerHeaderList" @click.stop="currentHeaderIndex = idx">
                                        {{ item }}
                                    </div>

                                </div>
                                <div class="icons-list">
                                    <div v-show="currentHeaderIndex == 0" class="icons-list-recommend">
                                        <div class="recommend-icon" v-for="(item, index) in recommondIconList" @click.stop="handleSelectSvgImg(item, index)">
                                            <img :src="item" alt=""/>
                                            <div v-if="item == spaceIconImg" class="icon-recommend-selected">
                                                <svg-icon name="setting-icon_setting_selected_icon" class="icon-recommend-selected-icon"></svg-icon>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-show="currentHeaderIndex == 1" class="icons-list-svg">
                                        <div class="svg-icon-list">
                                            <div class="svg-icon" :class="{ 'isCurrent': spaceIconSvg == item }" v-for="(item, index) in svgIconList" @click.stop="handleSelectSvgIcon(item)">
                                                <svg-icon :name="item" :color="spaceIconSvg == item ? svgCurrentColor : '#3C3E48'" class="svg-default-icon"></svg-icon>
                                            </div>
                                        </div>
                                        <div class="svg-colors-option">
                                            <div class="svg-colors-btn" v-for="(item, index) in svgColorList" :class="{ 'isCurrent': svgCurrentColor == item }" @click.stop="handleSelectSvgColor(item)">
                                                <div class="svg-colors-btn-inner" :style="{ backgroundColor: item }"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-show="currentHeaderIndex == 2" class="icon-upload">
                                        <input type="file" ref="iconInput" accept="image/png, image/jpeg, image/jpg" @change="onFileChange"/>
                                        <div v-if="!uploadImg" class="icon-upload-box" @click.stop="handleSelectUploadBtn">
                                            <svg-icon name="setting-icon_setting_upload" class="upload-icon"></svg-icon>
                                            <span>{{$t("上传图片")}}</span>
                                        </div>
                                        <div v-else class="icon-uploaded-img" @click.stop="handleSelectUploadBtn">
                                            <img :src="uploadImg" alt=""/>
                                        </div>

                                        <div class="icon-upload-tip">{{$t("请上传不超过5MB，且比例为1:1 的图片")}}</div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </a-trigger>

                </div>
            </div>
            <div class="basic-info-name">
                <div class="info-title">{{$t("名称")}}</div>
                <a-input class="input-space-name" v-model="spaceName" :placeholder="$t('名称不能为空')" :max-length="100" @input="modifySpaceName"></a-input>
            </div>
            <div class="basic-info-desc">
                <div class="info-desc">{{$t("简介")}}</div>
                <a-textarea class="info-desc-box" :placeholder="$t('请输入内容')" v-model="spaceDesc" :max-length="100" @input="modifyWikiSpaceDesc"></a-textarea>
            </div>
            <div class="basic-info-buttons">
                <div class="confirm-btn" :class="{ disabled: spaceName === '' }" @click="saveWikiSpaceInfo">{{$t("保存")}}                </div>
                <div class="cancel-btn" @click="cancelModified">{{$t("取消")}}</div>
            </div>
        </div>
    </a-spin>
</template>

<script lang="ts">
import { intl } from 'tci18n-vue3'
import { mapActions, mapState } from 'vuex';
import { getWikiSpaceInfo, modifyWikiSpaceInfo, uploadWikiIcon } from '../../core/api/setting';

import Icon2 from '../../assets/img/setting/icon_setting_icon_2.png';
import Icon3 from '../../assets/img/setting/icon_setting_icon_3.png';
import Icon4 from '../../assets/img/setting/icon_setting_icon_4.png';
import Icon5 from '../../assets/img/setting/icon_setting_icon_5.png';
import Icon6 from '../../assets/img/setting/icon_setting_icon_6.png';
import Icon7 from '../../assets/img/setting/icon_setting_icon_7.png';
import Icon8 from '../../assets/img/setting/icon_setting_icon_8.png';
import Icon9 from '../../assets/img/setting/icon_setting_icon_9.png';
import Icon10 from '../../assets/img/setting/icon_setting_icon_10.png';
import Icon11 from '../../assets/img/setting/icon_setting_icon_11.png';
import Icon12 from '../../assets/img/setting/icon_setting_icon_12.png';
import Icon13 from '../../assets/img/setting/icon_setting_icon_13.png';
import Icon14 from '../../assets/img/setting/icon_setting_icon_14.png';
import Icon15 from '../../assets/img/setting/icon_setting_icon_15.png';
import Icon16 from '../../assets/img/setting/icon_setting_icon_16.png';
import Icon17 from '../../assets/img/setting/icon_setting_icon_17.png';
import Icon18 from '../../assets/img/setting/icon_setting_icon_18.png';
import Icon19 from '../../assets/img/setting/icon_setting_icon_19.png';
import Icon20 from '../../assets/img/setting/icon_setting_icon_20.png';
import Icon21 from '../../assets/img/setting/icon_setting_icon_21.png';

import Svg1 from '../../assets/icons/setting/icon_setting_icon_1.svg';
import Svg2 from '../../assets/icons/setting/icon_setting_icon_2.svg';
import Svg3 from '../../assets/icons/setting/icon_setting_icon_3.svg';
import Svg4 from '../../assets/icons/setting/icon_setting_icon_4.svg';
import Svg5 from '../../assets/icons/setting/icon_setting_icon_5.svg';
import Svg6 from '../../assets/icons/setting/icon_setting_icon_6.svg';
import Svg7 from '../../assets/icons/setting/icon_setting_icon_7.svg';
import Svg8 from '../../assets/icons/setting/icon_setting_icon_8.svg';
import Svg9 from '../../assets/icons/setting/icon_setting_icon_9.svg';
import Svg10 from '../../assets/icons/setting/icon_setting_icon_10.svg';
import Svg11 from '../../assets/icons/setting/icon_setting_icon_11.svg';
import Svg12 from '../../assets/icons/setting/icon_setting_icon_12.svg';
import Svg13 from '../../assets/icons/setting/icon_setting_icon_13.svg';
import Svg14 from '../../assets/icons/setting/icon_setting_icon_14.svg';
import Svg15 from '../../assets/icons/setting/icon_setting_icon_15.svg';
import Svg16 from '../../assets/icons/setting/icon_setting_icon_16.svg';
import Svg17 from '../../assets/icons/setting/icon_setting_icon_17.svg';
import Svg18 from '../../assets/icons/setting/icon_setting_icon_18.svg';
import Svg19 from '../../assets/icons/setting/icon_setting_icon_19.svg';
import Svg20 from '../../assets/icons/setting/icon_setting_icon_20.svg';
import Svg21 from '../../assets/icons/setting/icon_setting_icon_21.svg';
import Svg22 from '../../assets/icons/setting/icon_setting_icon_22.svg';
import Svg23 from '../../assets/icons/setting/icon_setting_icon_23.svg';
import Svg24 from '../../assets/icons/setting/icon_setting_icon_24.svg';
import Svg25 from '../../assets/icons/setting/icon_setting_icon_25.svg';
import Svg26 from '../../assets/icons/setting/icon_setting_icon_26.svg';
import Svg27 from '../../assets/icons/setting/icon_setting_icon_27.svg';
import Svg28 from '../../assets/icons/setting/icon_setting_icon_28.svg';
import Svg29 from '../../assets/icons/setting/icon_setting_icon_29.svg';
import Svg30 from '../../assets/icons/setting/icon_setting_icon_30.svg';
import Svg31 from '../../assets/icons/setting/icon_setting_icon_31.svg';
import Svg32 from '../../assets/icons/setting/icon_setting_icon_32.svg';
import Svg33 from '../../assets/icons/setting/icon_setting_icon_33.svg';
import Svg34 from '../../assets/icons/setting/icon_setting_icon_34.svg';
import Svg35 from '../../assets/icons/setting/icon_setting_icon_35.svg';
import Svg36 from '../../assets/icons/setting/icon_setting_icon_36.svg';
import Svg37 from '../../assets/icons/setting/icon_setting_icon_37.svg';
import Svg38 from '../../assets/icons/setting/icon_setting_icon_38.svg';
import Svg39 from '../../assets/icons/setting/icon_setting_icon_39.svg';
import Svg40 from '../../assets/icons/setting/icon_setting_icon_40.svg';
import Svg41 from '../../assets/icons/setting/icon_setting_icon_41.svg';
import Svg42 from '../../assets/icons/setting/icon_setting_icon_42.svg';
import Svg43 from '../../assets/icons/setting/icon_setting_icon_43.svg';

export default {
  name: 'BasicInfoView',
  data() {
    return {
      isLoading: false,
      spaceName: '',
      spaceDesc: '',
      spaceIconImg: null,
      spaceIconSvg: null,
      defaultIconList: [
      Icon4, Icon5, Icon9, Icon10, Icon11, Icon12, Icon13, Icon14, Icon15, Icon16],

      defaultIconListIndex: [4, 5, 9, 10, 11, 12, 13, 14, 15],
      currentIconIndex: 2,
      showMoreIcon: false,
      triggerDisabled: false,
      triggerHeaderList: [intl.$t("推荐"), intl.$t("图标"), intl.$t("上传")],
      currentHeaderIndex: 0,

      recommondIconList: [Icon2, Icon3, Icon4, Icon5, Icon6, Icon7, Icon8, Icon9, Icon10, Icon11, Icon12, Icon13, Icon14, Icon15, Icon16, Icon17, Icon18, Icon19, Icon20, Icon21],
      svgIconList: [],
      svgColorList: ['#65A1FF', '#5C70FF', '#BB46FA', '#29CDB1', '#FFB621', '#43C966', '#F85353'],
      svgCurrentColor: '#3C3E48',

      uploadImg: null,

      uploadImgFile: null,

      nowSpaceInfo: {} };

  },
  emits: ['changeWikiSpaceIcon'],
  computed: {
    ...mapState({
      wikiSpaceInfo: (state) => state.kbTreeNodeModule.wikiSpaceInfo }),

    currentWikiSpaceId() {
      return this.wikiSpaceInfo.wikiSpaceId;
    } },

  methods: {
    ...mapActions({
      setWikiSpaceInfo: 'kbTreeNodeModule/setWikiSpaceInfo' }),


    getCurrentSpaceInfo() {
      this.isLoading = true;
      getWikiSpaceInfo(this.currentWikiSpaceId).
      then((res: any) => {
        const { code, message, data } = res.data;
        if (code == 200) {
          this.nowSpaceInfo = data;
          const { wikiSpaceIcon } = this.nowSpaceInfo;
          if (wikiSpaceIcon) {
            this.$emit('changeWikiSpaceIcon', wikiSpaceIcon.imageUrl);
            if (wikiSpaceIcon.imageKey) {
              if (wikiSpaceIcon.imageKey.startsWith('svg-') && wikiSpaceIcon.imageKey.includes('color-')) {
                const svgInfo = wikiSpaceIcon.imageKey;
                const iconMatch = svgInfo.match(/icon_setting_icon_(\d+)/);
                const colorMatch = svgInfo.match(/color-(.+)$/);
                if (iconMatch && colorMatch) {
                  const iconName = iconMatch[0];
                  this.spaceIconSvg = `setting-${iconName}`;
                  const colorValue = colorMatch[1];
                  this.svgCurrentColor = colorValue;
                }
                if (!this.spaceIconSvg) {
                  this.spaceIconImg = Icon2;
                } else {
                  this.spaceIconImg = null;
                }
              } else if (wikiSpaceIcon.imageKey.startsWith('png-')) {
                const imgInfo = wikiSpaceIcon.imageKey;
                const iconMatch = imgInfo.match(/icon_setting_icon_(\d+)/);
                if (iconMatch) {
                  const iconIndex = iconMatch[1];
                  this.spaceIconImg = this.iconAndSvgConfig(Number(iconIndex), false);
                } else {
                  this.spaceIconImg = Icon2;
                }
              }
            } else {
              this.spaceIconImg = wikiSpaceIcon.imageUrl;
            }
          } else {
            this.spaceIconImg = Icon2;
          }
        } else {
          this.spaceIconImg = Icon2;
        }
        this.isLoading = false;
      }).
      catch((err) => {
        this.$message.error(intl.$t("获取空间信息失败，请刷新重试"));
        this.isLoading = false;
      });
    },

    saveWikiSpaceNameAndDesc(wikiSpaceIcon: any) {
      modifyWikiSpaceInfo(
      this.currentWikiSpaceId,
      this.spaceName,
      this.spaceDesc,
      this.wikiSpaceInfo.visibleScope,
      wikiSpaceIcon).

      then((res: any) => {
        const { code, message } = res.data;
        if (code === 200) {
          this.$message.success(intl.$t("修改成功"));
          let currentSpaceInfo = this.wikiSpaceInfo;
          currentSpaceInfo.wikiSpaceName = this.spaceName;
          currentSpaceInfo.wikiSpaceDesc = this.spaceDesc;
          this.setWikiSpaceInfo(currentSpaceInfo);
          this.getCurrentSpaceInfo();
        } else {
          this.isLoading = false;
          this.$message.error(intl.$t(`修改失败，{message}`, { message: message }));
        }
      }).
      catch((err) => {
        this.isLoading = false;
        this.$message.error(intl.$t("修改失败，请重试"));
      });
    },

    saveWikiSpaceInfo() {
      this.isLoading = true;

      if (this.spaceIconSvg) {
        const svgIndex = this.spaceIconSvg.match(/setting_icon_(\d+)$/)[1];
        const svgPath = this.iconAndSvgConfig(Number(svgIndex), true);

        const formData = new FormData();
        fetch(svgPath).
        then((response) => response.text()).
        then((svgText) => {
          const modifiedSvgText = svgText.replace(/fill="[^"]*"/g, `fill="${this.svgCurrentColor}"`);
          const svgBlob = new Blob([modifiedSvgText], { type: 'image/svg+xml' });
          const url = URL.createObjectURL(svgBlob);
          const img = new Image();
          img.onload = () => {
            const canvas = document.createElement('canvas');
            canvas.width = img.width;
            canvas.height = img.height;
            const ctx = canvas.getContext('2d');
            ctx.fillStyle = '#FFFFFF';
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            ctx.drawImage(img, 0, 0);
            canvas.toBlob((blob) => {
              formData.append('image', blob, `${this.spaceIconSvg}.jpg`);
              formData.append('imageKey', `svg-icon_setting_icon_${svgIndex}_color-${this.svgCurrentColor}`);
              uploadWikiIcon(this.currentWikiSpaceId, formData).
              then((res) => {
                if (res.data?.code == 200) {
                  this.saveWikiSpaceNameAndDesc({
                    imageUrl: res.data.data.imageUrl,
                    imageKey: res.data.data.imageKey });

                } else {
                  this.isLoading = false;
                  this.$message.error(intl.$t(`图标上传失败，{slot0}`, { slot0: res.data?.message || '请重试' }));
                }
              }).
              catch((err) => {
                this.isLoading = false;
                this.$message.error(intl.$t("图标上传失败，请重试"));
              });
            }, 'image/jpeg');
            URL.revokeObjectURL(url);
          };
          img.src = url;
        }).
        catch((err) => {
          this.isLoading = false;
        });
      } else {

        const formData = new FormData();
        let imagePath: any;
        if (this.uploadImgFile && this.spaceIconImg) {
          imagePath = this.uploadImgFile;
          formData.append('image', imagePath);
          uploadWikiIcon(this.currentWikiSpaceId, formData).then((res: any) => {
            if (res.data?.code === 200) {
              this.saveWikiSpaceNameAndDesc({
                imageUrl: res.data.data.imageUrl,
                imageKey: res.data.data.imageKey });

            } else {
              this.isLoading = false;
              this.$message.error(intl.$t(`图标上传失败，{slot0}`, { slot0: res.data?.message || '请重试' }));
            }
          }).catch((err) => {
            this.$message.error(intl.$t("图标上传失败，请重试"));
            this.isLoading = false;
          });

        } else if (this.spaceIconImg && this.uploadImgFile == null) {
          if (this.spaceIconImg == this.nowSpaceInfo.wikiSpaceIcon?.imageUrl) {
            this.saveWikiSpaceNameAndDesc({
              imageUrl: this.nowSpaceInfo.wikiSpaceIcon.imageUrl,
              imageKey: this.nowSpaceInfo.wikiSpaceIcon.imageKey });

            return;
          }
          const imgIndex = this.currentIconIndex;
          const imgPath = this.iconAndSvgConfig(Number(imgIndex), false);
          fetch(imgPath).
          then((response) => response.blob()).
          then((blob) => {
            formData.append('image', blob, `icon_setting_icon_${imgIndex}.png`);
            formData.append('imageKey', `png-icon_setting_icon_${imgIndex}`);
            return uploadWikiIcon(this.currentWikiSpaceId, formData);
          }).
          then((res: any) => {
            if (res.data?.code === 200) {
              this.saveWikiSpaceNameAndDesc({
                imageUrl: res.data.data.imageUrl,
                imageKey: res.data.data.imageKey });

            } else {
              this.isLoading = false;
              this.$message.error(intl.$t(`图标上传失败，{slot0}`, { slot0: res.data?.message }));
            }
          }).
          catch((err) => {
            this.$message.error(intl.$t("图标上传失败，请重试"));
            this.isLoading = false;
          });
        }
      }
    },
    cancelModified() {
      this.spaceName = this.wikiSpaceInfo.wikiSpaceName;
      this.spaceDesc = this.wikiSpaceInfo.wikiSpaceDesc;
      this.uploadImgFile = null;
      this.uploadImg = null;
      this.spaceIconSvg = null;
      this.svgCurrentColor = '#3C3E48';

      const { wikiSpaceIcon } = this.nowSpaceInfo;
      if (wikiSpaceIcon) {
        if (wikiSpaceIcon.imageKey) {
          if (wikiSpaceIcon.imageKey.startsWith('svg-') && wikiSpaceIcon.imageKey.includes('color-')) {
            const svgInfo = wikiSpaceIcon.imageKey;
            const iconMatch = svgInfo.match(/icon_setting_icon_(\d+)/);
            const colorMatch = svgInfo.match(/color-(.+)$/);
            if (iconMatch && colorMatch) {
              const iconName = iconMatch[0];
              this.spaceIconSvg = `setting-${iconName}`;
              const colorValue = colorMatch[1];
              this.svgCurrentColor = colorValue;
            }
            if (!this.spaceIconSvg) {
              this.spaceIconImg = Icon2;
              this.currentIconIndex = 2;
            } else {
              this.spaceIconImg = null;
            }
          } else if (wikiSpaceIcon.imageKey.startsWith('png-')) {
            const imgInfo = wikiSpaceIcon.imageKey;
            const iconMatch = imgInfo.match(/icon_setting_icon_(\d+)/);
            if (iconMatch) {
              const iconIndex = iconMatch[1];
              this.spaceIconImg = this.iconAndSvgConfig(Number(iconIndex), false);
              this.currentIconIndex = iconIndex;
            } else {
              this.spaceIconImg = Icon2;
              this.currentIconIndex = 2;
            }
          }
        } else {
          this.spaceIconImg = wikiSpaceIcon.imageUrl;
        }
      } else {
        this.spaceIconImg = Icon2;
        this.currentIconIndex = 2;
      }
    },
    modifySpaceName(val: string, ev: Event) {
      let newSpaceName: string = val;
    },
    modifyWikiSpaceDesc(val: string, ev: Event) {
      let newSpaceDesc: string = val;
    },

    handleSelectDefaultIcon(item: any, index: number) {
      if (item != 'setting-icon_setting_img_more') {
        this.triggerDisabled = true;
        this.spaceIconImg = item;
        this.spaceIconSvg = null;
        if (this.uploadImgFile) {
          this.uploadImgFile = null;
        }
        this.currentIconIndex = this.defaultIconListIndex[index];
      } else {
        this.handleChangeIcon();
      }
    },

    handleChangeIcon() {
      this.triggerDisabled = false;
      this.showMoreIcon = true;
    },

    createSvgIconList() {
      for (let index = 1; index < 44; index++) {
        this.svgIconList.push(`setting-icon_setting_icon_${index}`);
      }
    },

    handleSelectSvgImg(item: any, index: number) {
      this.spaceIconImg = item;
      this.currentIconIndex = index + 2;
      if (this.spaceIconSvg) {
        this.spaceIconSvg = null;
      }
      if (this.uploadImg) {
        this.uploadImg = null;
      }
      if (this.uploadImgFile) {
        this.uploadImgFile = null;
      }
    },

    handleSelectSvgIcon(item: string) {
      this.spaceIconSvg = item;
      if (this.spaceIconImg) {
        this.spaceIconImg = null;
      }
      if (this.uploadImg) {
        this.uploadImg = null;
      }
      if (this.uploadImgFile) {
        this.uploadImgFile = null;
      }
    },

    handleSelectSvgColor(item: any) {
      if (this.svgCurrentColor == '#3C3E48') {
        this.svgCurrentColor = item;
      } else {
        if (this.svgCurrentColor == item) {
          this.svgCurrentColor = '#3C3E48';
        } else {
          this.svgCurrentColor = item;
        }
      }
    },

    handleSelectUploadBtn() {
      this.$refs.iconInput.click();
    },

    onFileChange(event: any) {

      const file = event.target.files[0];
      if (!file) return;
      if (file.size > 5 * 1024 * 1024) {
        this.$message({ message: intl.$t("请上传不超过5MB的图片"), type: "error" });
        return;
      }
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (e) => {
        const result = e.target?.result;
        if (typeof result === 'string') {
          const image = new Image();
          image.src = result;
          image.onload = () => {
            if (this.spaceIconSvg) {
              this.spaceIconSvg = null;
            }
            this.spaceIconImg = this.uploadImg = result;
            this.uploadImgFile = file;
          };
        } else {
          this.$message({ message: intl.$t("文件读取失败，请重新上传"), type: "error" });
        }

      };
    },

    iconAndSvgConfig(index: number, isSvg: boolean) {
      let path: any;
      switch (index) {
        case 1:
          path = Svg1;
          break;
        case 2:
          path = isSvg ? Svg2 : Icon2;
          break;
        case 3:
          path = isSvg ? Svg3 : Icon3;
          break;
        case 4:
          path = isSvg ? Svg4 : Icon4;
          break;
        case 5:
          path = isSvg ? Svg5 : Icon5;
          break;
        case 6:
          path = isSvg ? Svg6 : Icon6;
          break;
        case 7:
          path = isSvg ? Svg7 : Icon7;
          break;
        case 8:
          path = isSvg ? Svg8 : Icon8;
          break;
        case 9:
          path = isSvg ? Svg9 : Icon9;
          break;
        case 10:
          path = isSvg ? Svg10 : Icon10;
          break;
        case 11:
          path = isSvg ? Svg11 : Icon11;
          break;
        case 12:
          path = isSvg ? Svg12 : Icon12;
          break;
        case 13:
          path = isSvg ? Svg13 : Icon13;
          break;
        case 14:
          path = isSvg ? Svg14 : Icon14;
          break;
        case 15:
          path = isSvg ? Svg15 : Icon15;
          break;
        case 16:
          path = isSvg ? Svg16 : Icon16;
          break;
        case 17:
          path = isSvg ? Svg17 : Icon17;
          break;
        case 18:
          path = isSvg ? Svg18 : Icon18;
          break;
        case 19:
          path = isSvg ? Svg19 : Icon19;
          break;
        case 20:
          path = isSvg ? Svg20 : Icon20;
          break;
        case 21:
          path = isSvg ? Svg21 : Icon21;
          break;
        case 22:
          path = Svg22;
          break;
        case 23:
          path = Svg23;
          break;
        case 24:
          path = Svg24;
          break;
        case 25:
          path = Svg25;
          break;
        case 26:
          path = Svg26;
          break;
        case 27:
          path = Svg27;
          break;
        case 28:
          path = Svg28;
          break;
        case 29:
          path = Svg29;
          break;
        case 30:
          path = Svg30;
          break;
        case 31:
          path = Svg31;
          break;
        case 32:
          path = Svg32;
          break;
        case 33:
          path = Svg33;
          break;
        case 34:
          path = Svg34;
          break;
        case 35:
          path = Svg35;
          break;
        case 36:
          path = Svg36;
          break;
        case 37:
          path = Svg37;
          break;
        case 38:
          path = Svg38;
          break;
        case 39:
          path = Svg39;
          break;
        case 40:
          path = Svg40;
          break;
        case 41:
          path = Svg41;
          break;
        case 42:
          path = Svg42;
          break;
        case 43:
          path = Svg43;
          break;
        default:
          break;}

      return path;
    } },


  created() {
    this.spaceName = this.wikiSpaceInfo.wikiSpaceName;
    this.spaceDesc = this.wikiSpaceInfo.wikiSpaceDesc;

    this.getCurrentSpaceInfo();
    this.createSvgIconList();
  } };
</script>

<style lang="scss" scoped>
.basic-info-view {
    height: calc(100% - 94px);

    .basic-info-icon {
        margin: 40px 24px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        flex-wrap: nowrap;

        .icon-title {
            font-family: PingFangSC-Medium;
            font-weight: 500;
            font-size: 14px;
            color: #121317;
            line-height: 20px;
        }

        .icon-setting {
            margin-top: 16px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: flex-start;

            .icon-input-box {
                width: 120px;
                height: 120px;
                border: 1px solid #E8E9EE;
                border-radius: 4px;
                box-sizing: border-box;

                .icon-show-img {
                    width: 120px;
                    height: 120px;
                }

                .icon-show-svg {
                    width: 120px;
                    height: 120px;
                }

            }

            .icon-list {
                width: 220px;
                height: 120px;
                margin-left: 16px;
                display: flex;
                flex-direction: column;

                .icon-default-list {
                    width: 100%;
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: flex-start;

                    >* {
                        margin: 0 4px 4px 0;
                    }

                    .icon-default-item {
                        width: 40px;
                        height: 40px;
                        border-radius: 4px;
                        cursor: pointer;
                        position: relative;

                        .icon-default-img {
                            width: 40px;
                            height: 40px;
                            border-radius: 4px;
                        }

                        &.more-btn {
                            border: 1px solid #E8E9EE;
                            border-radius: 4px;
                            box-sizing: border-box;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        }

                        .icon-default-more-btn {
                            width: 30px;
                            height: 30px;
                        }

                        .icon-default-selected {
                            width: 40px;
                            height: 40px;
                            border-radius: 4px;
                            background: #2223294d;
                            border-radius: 4px;
                            position: absolute;
                            top: 0;
                            left: 0;
                            display: flex;
                            align-items: center;
                            justify-content: center;

                            .icon-default-selected-icon {
                                width: 17px;
                                height: 17px;
                            }
                        }
                    }
                }

                .icon-change-btn {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 216px;
                    height: 32px;
                    border: 1px solid #E8E9EE;
                    border-radius: 4px;
                    box-sizing: border-box;
                    background: #FFFFFF;
                    font-family: PingFangSC-Regular;
                    font-weight: 400;
                    font-size: 14px;
                    color: #222329;
                    text-align: center;
                    line-height: 20px;
                    cursor: pointer;
                }

            }
        }
    }

    .basic-info-name {
        margin: 40px 24px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        flex-wrap: nowrap;

        .info-title {
            font-family: PingFangSC-Medium;
            font-weight: 500;
            font-size: 14px;
            color: #121317;
            line-height: 20px;
        }

        .input-space-name {
            margin-top: 16px;
            background: #ffffff;
            border: 1px solid #e8e9ee;
            border-radius: 4px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 14px;
            color: #222329;
            line-height: 20px;

            &:focus-within {
                border: 1px solid #5c70ff;
                border-radius: 4px;
            }
        }
    }

    .basic-info-desc {
        margin: 40px 24px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        flex-wrap: nowrap;

        .info-desc {
            font-family: PingFangSC-Medium;
            font-weight: 500;
            font-size: 14px;
            color: #121317;
            line-height: 20px;
        }

        .info-desc-box {
            margin-top: 16px;
            background: #ffffff;
            border: 1px solid #e8e9ee;
            border-radius: 4px;
            height: 112px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 14px;
            color: #222329;
            line-height: 20px;

            &:focus-within {
                border: 1px solid #5c70ff;
                border-radius: 4px;
            }
        }
    }

    .basic-info-buttons {
        margin: 40px 24px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;

        .confirm-btn {
            width: 76px;
            height: 32px;
            background: #5c70ff;
            border-radius: 8px;
            font-family: PingFangSC-Medium;
            font-weight: 500;
            font-size: 14px;
            color: #ffffff;
            text-align: center;
            line-height: 20px;
            margin-right: 12px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            cursor: pointer;

            &:hover {
                background: #6d7dff;
                border-radius: 8px;
            }
        }

        .confirm-btn.disabled {
            width: 76px;
            height: 32px;
            background: #ced4ff;
            border-radius: 8px;
            font-family: PingFangSC-Medium;
            font-weight: 500;
            font-size: 14px;
            color: #ffffff;
            text-align: center;
            line-height: 20px;
            margin-right: 12px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            pointer-events: none;
            cursor: not-allowed;
        }

        .cancel-btn {
            width: 76px;
            height: 32px;
            background: #ffffff;
            border: 1px solid #e6e8ec;
            border-radius: 8px;
            font-family: PingFangSC-Medium;
            font-weight: 500;
            font-size: 14px;
            color: #222329;
            text-align: center;
            line-height: 20px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            cursor: pointer;

            &:hover {
                background: #f4f6f9;
                border: 1px solid #e6e8ec;
                border-radius: 8px;
            }
        }
    }
}

.icon-setting-view {
    width: 464px;
    height: 412px;
    box-sizing: border-box;
    background: #FFFFFF;
    border: 1px solid #E6E8EC;
    box-shadow: 0 10px 20px 6px #2223291a;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;

    .icon-setting-header {
        width: 100%;
        height: 51px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        padding: 0 16px;
        box-sizing: border-box;
        border-bottom: 1px solid #E6E8EC;

        .icon-header-item {
            height: 100%;
            margin-right: 24px;
            box-sizing: border-box;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 14px;
            color: #747677;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;

            &.selected {
                font-family: PingFangSC-Medium;
                font-weight: 500;
                font-size: 14px;
                color: #222329;
                border-bottom: 2px solid #5C70FF;
            }
        }
    }

    .icons-list {
        width: 100%;
        height: calc(100% - 51px);

        .icons-list-recommend {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            justify-content: center;
            overflow-x: hidden;
            overflow-y: auto;
            margin-top: 4px;

            >* {
                margin: 4px;
            }

            .recommend-icon {
                width: 80px;
                height: 80px;
                border-radius: 8px;
                cursor: pointer;
                position: relative;

                img {
                    width: 80px;
                    height: 80px;
                    border-radius: 8px;
                }

                .icon-recommend-selected {
                    width: 80px;
                    height: 80px;
                    border-radius: 8px;
                    background: #2223294d;
                    position: absolute;
                    top: 0;
                    left: 0;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    .icon-recommend-selected-icon {
                        width: 17px;
                        height: 17px;
                    }
                }
            }
        }

        .icons-list-svg {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: flex-start;
            height: 100%;
            position: relative;

            .svg-icon-list {
                margin-top: 4px;
                padding: 0 10.5px;
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                justify-content: flex-start;
                overflow-x: hidden;
                overflow-y: auto;

                >* {
                    margin: 4.5px;
                }

                .svg-icon {
                    width: 40px;
                    height: 40px;
                    cursor: pointer;

                    &:hover,
                    &.isCurrent {
                        background: #f4f6f9;
                        border-radius: 4px;
                    }

                    .svg-default-icon {
                        padding: 8px;
                        width: 24px;
                        height: 24px;
                    }
                }
            }


            .svg-colors-option {
                width: calc(100% - 48px);
                height: 48px;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;
                padding: 0 24px;
                position: absolute;
                bottom: 0;
                left: 0;

                .svg-colors-btn {
                    width: 20px;
                    height: 20px;
                    border-radius: 50%;
                    box-sizing: border-box;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;

                    &.isCurrent {
                        border: 1px solid #5C70FF;
                    }

                    .svg-colors-btn-inner {
                        width: 16px;
                        height: 16px;
                        border-radius: 50%;
                    }
                }
            }
        }

        .icon-upload {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            height: 100%;
            width: 100%;

            input[type="file"] {
                display: none;
            }

            .icon-upload-box {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                width: 80px;
                height: 80px;
                background: #FFFFFF;
                border: 1px solid #EFEFF0;
                border-radius: 6px;
                box-sizing: border-box;
                cursor: pointer;

                .upload-icon {
                    width: 18px;
                    height: 18px;
                }

                span {
                    margin-top: 4px;
                    font-family: PingFangSC-Regular;
                    font-weight: 400;
                    font-size: 12px;
                    color: #747677;
                    text-align: center;
                }
            }

            .icon-uploaded-img {
                width: 80px;
                height: 80px;
                cursor: pointer;

                img {
                    width: 80px;
                    height: 80px;
                    border-radius: 6px;
                }
            }

            .icon-upload-tip {
                margin-top: 8px;
                font-family: PingFangSC-Regular;
                font-weight: 400;
                font-size: 12px;
                color: #A5A7B3;
                text-align: center;
            }
        }
    }
}
</style>
